import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { ReplaySubject, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CustomerService } from 'modules/core/services/customer.service';
import { DocumentsService, IDocumentsRequest } from 'modules/core/services/documents.service';

import { PeriodicReviewResponse } from 'modules/shared/models/periodic-review.models';
import { ITasksRes, Task, ITasksStats } from 'modules/shared/models/task.models';
import { DocumentResponse } from 'store/models/document.models';

import { TasksService } from '../../services/tasks.service';

import { environment } from 'environments/environment';

@Component({
  selector: 'artemis-dashboard-page',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardPage implements OnInit, OnDestroy {

  private unsubscribe$: ReplaySubject<any> = new ReplaySubject<any>(1);

  pendingTasks: Array<Task>;
  overdueTasks: Array<Task>;
  stats: ITasksStats;

  enableHandshakes: boolean = environment['ENABLE_HANDSHAKES'];
  enableOpenCorporates: boolean = environment['ENABLE_OPENCORPORATES'];

  constructor(private tasksService: TasksService,
              private cdRef: ChangeDetectorRef,
              private customersService: CustomerService,
              private documentsService: DocumentsService) { }

  ngOnInit() {
    this.getTasksStats();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  /**
   * Get stats for populating donut chart
   * @method getTasksStats
   */
  private getTasksStats(): void {
    zip(
      this.tasksService.getTasks('PENDING'),
      this.tasksService.getTasks('OVERDUE'),
      this.customersService.loadPeriodicReview(),
      this.documentsService.getDocuments(<IDocumentsRequest>{show_expiry_alerts: true, expiring: true})
    )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        ([pendingTaskRes, overdueTaskRes, periodicReviewRes, documentsRes]:
         [ITasksRes, ITasksRes, PeriodicReviewResponse, DocumentResponse]) => {
          this.pendingTasks = pendingTaskRes.results;
          this.overdueTasks = overdueTaskRes.results;

          this.stats = <ITasksStats>{
            expiringDocCount: documentsRes.count,
            ongoingDueDiligenceCount: periodicReviewRes.count,
            pendingTaskCount: pendingTaskRes.count,
            overdueTaskCount: overdueTaskRes.count
          };

          this.cdRef.detectChanges();
        }
      );
  }
}
